// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountValue } from './account-value';
import { AdminBankrupt } from './admin-bankrupt';
import { BankruptAddress } from './bankrupt-address';
import { BankruptNumber } from './bankrupt-number';
import { Contact } from './contact';
import { Contribution } from './contribution';
import { Counterparty } from './counterparty';
import { DocumentRecipient } from './document-recipient';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Bankrupt extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  bankruptId!: number;
  accountantContactId?: number;
  bankruptcyDate?: Date;
  businessAbn?: string;
  businessAddressAddressId?: number;
  businessEndDate?: string;
  businessName?: string;
  businessNature?: string;
  businessStartDate?: string;
  businessTaxBasis?: number;
  businessType?: number;
  compFlags?: number;
  contactPersonContactId?: number;
  countryOfIssue?: string;
  courtName?: string;
  courtOrderDate?: Date;
  courtProceedingMatterNo?: string;
  courtProceedingYear?: string;
  createdBy!: string;
  createdDate!: Date;
  dateOfBirth?: Date;
  dependantsNumber?: number;
  dependantsTotalIncome!: number;
  dischargeDate?: Date;
  edagrantDate?: Date;
  edareceiveDate?: Date;
  edarejectDate?: Date;
  edastatus?: number;
  employerCounterpartyId?: number;
  fhagrantDate?: Date;
  fhareceiveDate?: Date;
  fharejectDate?: Date;
  fhastatus?: number;
  financialDifficultyDate?: Date;
  firstName?: string;
  gender?: string;
  hasPrivateMedicalCover!: boolean;
  hasSalarySacrifice!: boolean;
  hasSpouse!: boolean;
  ieflags?: number;
  isBusinessOperating?: boolean;
  isBusinessOperator!: boolean;
  isEmaiRecipient!: boolean;
  isEmployed!: boolean;
  isMdlholder!: boolean;
  isPassportHolder!: boolean;
  isResidenceOwner!: boolean;
  lastName!: string;
  mdlexpiry?: Date;
  mdlnumber?: string;
  mdlorigin?: string;
  memo?: string;
  memo1?: string;
  memo2?: string;
  memo3?: string;
  nativeLanguage?: string;
  occupation?: string;
  passportExpiry?: Date;
  passportNumber?: string;
  passportSurrenderDate?: Date;
  previousNames?: string;
  residesWithSpouse!: boolean;
  solicitorContactId?: number;
  spouseName?: string;
  spouseTotalIncome!: number;
  tfn?: string;
  title?: string;
  totalBenefits!: number;
  totalDeductions!: number;
  totalOtherIncomes!: number;
  totalWagesIncome!: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  wagesPeriod?: number;
  accountValues!: AccountValue[];
  accountantContact!: Contact;
  adminBankrupts!: AdminBankrupt[];
  bankruptAddresses!: BankruptAddress[];
  bankruptNumbers!: BankruptNumber[];
  contactPersonContact!: Contact;
  contributions!: Contribution[];
  documentRecipients!: DocumentRecipient[];
  employerCounterparty!: Counterparty;
  solicitorContact!: Contact;
}

